var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading && _vm.items.show_message)?_c('div',[_c('v-alert',{staticClass:"mb-2",attrs:{"type":"info","icon":"mdi-package-variant","text":"","dense":""}},[_vm._v(" "+_vm._s(_vm.items.message)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }